import { render } from "./BomInfo.vue?vue&type=template&id=3b60ac3c&scoped=true"
import script from "./BomInfo.vue?vue&type=script&lang=js"
export * from "./BomInfo.vue?vue&type=script&lang=js"

import "./BomInfo.vue?vue&type=style&index=0&id=3b60ac3c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b60ac3c"]])

export default __exports__